import React from 'react';

const Body = ({ children }) => (
  <div className="desktop:mx-8.2 pb-12">{children}</div>
);

export default Body;
